import { useClickOutside } from '@mnd-frontend/hooks';
import { Badge } from '@mnd-frontend/ui/publish/components';
import { media } from '@mnd-frontend/ui/publish/utils';
import { SPACING_2, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { track } from '../../../../../lib/tracker';
import HeaderPillMenu from '../../../../../modules/trial/HeaderPillMenu';

const TrialContentWrapper = styled.div`
  position: absolute;
  z-index: 102;
  top: 60px;
  left: calc(var(--mnd-navigation-width) - 0.5rem);
  ${media.greaterThan('navigationBreakpoint')} {
    top: 5%;
    left: calc(var(--mnd-navigation-width) - 0.5rem);
  }
`;

const Item = styled.div<{ $positionAbsolute: boolean }>`
  ${({ $positionAbsolute }) =>
    $positionAbsolute &&
    css`
      position: absolute;
      left: ${SPACING_3};
      top: ${SPACING_2};
    `}
  display: grid;
  place-items: center;
  margin-left: ${SPACING_2};
  ${media.greaterThan('navigationBreakpoint')} {
    margin-left: unset;
  }
`;

const PillButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  &:focus {
    outline: none;
  }
`;

const TrialMenuItem = ({
  isOpen,
  positionAbsolute = false,
  open,
  close,
}: {
  isOpen: boolean;
  positionAbsolute?: boolean;
  open: () => void;
  close: () => void;
}) => {
  const { t } = useTranslation();
  const [disableOutsideClick, setDisableOutsideClick] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(
    ref,
    () => {
      if (isOpen && !disableOutsideClick) {
        close();
      }
    },
    isOpen,
  );

  return (
    <Item ref={ref} $positionAbsolute={positionAbsolute}>
      <PillButton
        type="button"
        onClick={() => {
          if (isOpen) {
            close();
          } else {
            track({ event: 'Header - Open Trial pill', traits: { pill_text: 'Trial' } });
            open();
          }
        }}
        aria-label={t('aria_label_toggle_trial_button')}
      >
        <Badge text={'Trial'} variant="commercial" />
      </PillButton>
      {isOpen && (
        <TrialContentWrapper>
          <HeaderPillMenu
            closeTrialMenu={() => close()}
            setDisableOutsideClick={setDisableOutsideClick}
          />
        </TrialContentWrapper>
      )}
    </Item>
  );
};

export default TrialMenuItem;
